import { Injectable } from '@angular/core';

import { CasinoManager, ConfigProviderService } from '@casinocore/platform/core';

import { JackpotRibbon } from '../models/jackpot.models';
import { FeatureConfig, GameConfig, SubNavConfig } from '../models/modular-config.models';

@Injectable({
    providedIn: 'root',
})
export class JackpotRibbonRenderService {
    featureConfig: FeatureConfig;
    constructor(
        private readonly configProviderService: ConfigProviderService,
        private readonly casinoManager: CasinoManager,
    ) {
        this.featureConfig = this.configProviderService.provideFeaturesConfig();
    }

    getJackpoRibbonData(lobbyType: string): JackpotRibbon {
        return {
            withIcon: this.getHotIconStatus(lobbyType),
            iconImage: this.getHotIconImage(),
        };
    }

    private getHotIconStatus(lobbyType: string) {
        return this.casinoManager.IsFeatureEnabledforLobbytype(lobbyType, this.featureConfig.enableHotIcon);
    }

    private getHotIconImage() {
        const gameConfig: GameConfig = this.configProviderService.provideGameConfig();
        return `${gameConfig.host}${this.getHotIconPath()}`;
    }

    private getHotIconPath() {
        const subnavConfig: SubNavConfig = this.configProviderService.provideSubNavigationConfig();
        return subnavConfig.enableEpcotSubNavigation ? this.featureConfig.hotIconPath.epcotHotIcon : this.featureConfig.hotIconPath.hotIcon;
    }
}
